<script setup lang="ts">
import { useSlots } from 'vue';

withDefaults(defineProps<{
  label: string,
  value?: unknown,
}>(), {
  label: '',
  value: undefined,
});

const slots = useSlots();
const hasDefaultSlot = !!slots.default;
</script>

<template>
  <div class="subscription-details-section__item">
    <span class="subscription-details-section__label">{{ label }}</span>
    <span class="subscription-details-section__value">
      <template v-if="hasDefaultSlot">
        <slot />
      </template>
      <template v-else>
        {{ value }}
      </template>
    </span>
  </div>
</template>
